import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'

export const ErrorMessage: React.FC<{ errorMessage: string }> = ({ errorMessage }) => {
  return <NoticeBox title={errorMessage} noticeBoxType='Error' hasBorder={false} />
}
